export const TASK_STATUS = {
  OPEN: 'OPEN',
  COMPLETE: 'COMPLETE',
  REJECTED: 'REJECTED'
};

export const TASK_NAMES = {
  CONTACT_INFO: 'CONTACT_INFO',
  PRACTICE_INFO: 'PRACTICE_INFO',
  SELECT_PLANS: 'SELECT_PLANS',
  BO_SIGNIFICANT_OWNER_FLAG_INFO: 'BO_SIGNIFICANT_OWNER_FLAG_INFO',
  BO_OWNERSHIP_INFO: 'BO_OWNERSHIP_INFO',
  BO_SIGNIFICANT_OWNER_INFO: 'BO_SIGNIFICANT_OWNER_INFO',
  ACH_INFO: 'ACH_INFO',
  REVIEW_INFO: 'REVIEW_INFO',
  PROVIDER_AGREEMENT: 'PROVIDER_AGREEMENT'
};

export const APPLICATION_STATUSES = {
   REGISTERED: 'REGISTERED',
   DRAFT: 'DRAFT'
};

